export function fromEntries(entries) {
    const o = {};
    entries.forEach(([k, v]) => o[k] = v);
    return o;
}
export function toUrlParam(param, encode = true) {
    const obj = fromEntries(Object.entries(param).filter(([_, v]) =>
        v !== undefined));
    const entries = Object.entries(obj);
    if (encode) {
        return entries.map(([key, value]) => `${key}=${encodeURIComponent(value)}`).join('&');
    }
    return entries.map(([key, value]) => `${key}=${value}`).join('&');
}

export function getUrlParam(needDecode = true) {
    const { search } = window.location;
    if (!search || search.length === 0) { return {}; }
    function splitByEq(o) {
        const i = o.indexOf('=');
        return [o.substring(0, i), o.substring(i + 1)];
    };
    const transFunc = needDecode ? o => {
        const [k, v] = splitByEq(o);
        return [k, decodeURIComponent(v)];
    } : splitByEq;
    const entries = search.substring(1).split('&').map(transFunc);
    return fromEntries(entries);
}


// WEBPACK FOOTER //
// ./src/utils/url.js